import React, { useRef } from "react";
import classNames from "classnames";
import nointerviewsimage from "../../assests/nointerviewshere.png";
import {
  interviewsProList,
  loginWarningImage,
} from "../../helpers/constantVariables";
import {
  MdAvTimer,
  MdOutlineCalendarMonth,
  MdArrowCircleRight,
  MdOutlineAdd,
  MdFileUpload,
  MdDeleteOutline,
  MdOutlineCorporateFare,
  MdOutlineQuestionAnswer,
} from "react-icons/md";
import {
  AiOutlineClose,
  AiOutlineCloseCircle,
  AiOutlineCopy,
  AiOutlineDownCircle,
  AiOutlineReconciliation,
  AiOutlineShareAlt,
} from "react-icons/ai";
import axios from "axios";
import { pdfjs } from "react-pdf";
import { FiAlertTriangle } from "react-icons/fi";
import { BiEditAlt } from "react-icons/bi";
import { useState, useEffect } from "react";
import "./dashboard.css";
import { Observer } from "mobx-react";
import CreditPoints, { PurchaseCredits } from "./creditPoints";
import { useStores } from "../../store/index";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import HelpCenter from "../reusble_components/helpCenter";
import MobileBottomNavBar from "../navbar/mobileNavbar";
import { GetMoreCreditsPopUp, RedeemCoupon } from "./basicDetails";
import MobileVerification from "./mobileVerification";
import ReferAndEarn from "./ReferAndEarn";
import CompanyBasedInnterview from "./CompanyBasedInnterview";
import referal from "../../referal.svg";
import KnowMore from "./knowMore";
import Create from "./create";
import TopicBasedInterview from "./topicBasedInterview";
import { ProfilePic } from "./profilePic";
import { uploadFileToAzure } from "../../services/azure";
import { FaCircleNotch, FaCode, FaPlus } from "react-icons/fa";
import { IoInformationCircleOutline } from "react-icons/io5";
import { getUserRoleFromLocalStorage } from "../../services/reusable";
import { setDataToLocalStorage } from "../../services/localStorage";
import { apiPostPut } from "../../api/api_methods";
import { createInterview } from "../../api/recruiterAssessmentsApi";
import { IoAddCircleOutline } from "react-icons/io5";
import Tooltip from "../reusble_components/tooltip";
import { interviewsList, showNewUi } from "../../helpers/constantVariables";
import { InterviewList } from "./create";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Popup from "../reusble_components/popup";
import FacingProblem from "./facingProblem";
import eerorImage from "../../assests/under-construction.png";
import TermsAndConditionsPopup from "./termsAndConditionsPopup";
import ResponsiveHeader from "../reusble_components/labels3/responsiveHeader";
import { HiOutlineBriefcase, HiOutlineUsers } from "react-icons/hi2";
import { BsPersonWorkspace } from "react-icons/bs";
import { SlSpeech } from "react-icons/sl";
import ProgressBar from "../reusble_components/profileProgress";
import { view } from "../../services/white_label";
import { ImSortAmountAsc } from "react-icons/im";
export default function Dashboard() {
  const navigate = useNavigate();
  const { CommonStore, PopupStore } = useStores();
  // const { LearningStore } = useStores();
  // const [availableCredits, setAvailableCredits] = useState(0);

  // const handleButtonClick = (e) => {
  //   e.preventDefault();
  //   console.log("submitting");
  //   // console.log('name:', name);
  //   //   console.log( 'technology:', technology );
  //   //   console.log( 'number of questions:', noOfQuestions );
  //   //   console.log( 'level:', level );
  //   const errors = {};
  //   // Perform form validation
  //   //   if (!name) {
  //   //     errors.name = "Name is required";
  //   //
  //   //   }
  //   //   if (!technology) {
  //   //     errors.technology = "Technology is required";
  //   // }
  //   console.log("checked");
  //   // if (!description) {
  //   //   errors.description = "Description is required";
  //   // }

  //   if (Object.keys(errors).length === 0) {
  //     // All fields are valid, submit the form
  //     console.log("Form submitted:", { name, technology, level });
  //   } else {
  //     // Display validation errors
  //     setErrors(errors);
  //     console.log("errors", errors);
  //   }

  //   console.log("event done");

  //   console.log("name", name);
  // };
  const [isNotChrome, setIsNotChrome] = useState(false);

  const freeInterviews = [
    {
      title: "Technical Mock Interview",
      id: 2, // interview id // 2 is with resume 1 is without resume
      sort: 1,
      description:
        "Mock practice at 60% efficiency builds a solid foundation, boosting confidence and enabling initial self-assessment.",
      active: true,
      type: "basic",
      company: true,
      icon: <HiOutlineBriefcase />,
    },
    // {
    //   img: <AiOutlineFileDone />,
    //   title: "Resume Based Interview",

    //   id: 2, // interview id
    //   sort: 3,
    //   description:
    //     "Efficient Initial Screening: A resume interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    //   active: true,
    //   type: "resume",
    // },
    {
      // img: <BsBuildings />,
      title: "Company Specific Interview",
      id: 4, // interview id // 4 is with resume  3 is without resume
      sort: 4,
      description:
        "The company’s interview process efficiently evaluates candidates' skills and cultural fit through diverse formats.",
      active: true,
      type: "company",
      icon: <MdOutlineCorporateFare className="w-8 h-8" />,
    },
    // {
    //   img: <BsBuildingCheck />,
    //   title: "Company Interview with Resume",
    //   id: 4, // interview id
    //   sort: 5,
    //   description:
    //     "Efficient Comprehensive Assessment: Combining traditional elements with a resume-based evaluation, this interview efficiently assesses a candidate's background and alignment with the company's needs and culture.",
    //   active: true,
    //   type: "resume, company",
    // },
    {
      img: <BsPersonWorkspace />,
      title: "HR Interview",
      id: 8, // interview id // 8 is with resume  5 is without resume
      sort: 6,
      description:
        "HR interview efficiently screens candidates, quickly assessing qualifications and potential job alignment based on resumes.",
      active: true,
      company: true,
      icon: <HiOutlineUsers className="w-8 h-8" />,
    },
    {
      img: <BsPersonWorkspace />,
      title: "Coding Interview",
      id: 10, // interview id // 10 is with resume  5 is without resume
      sort: 6,
      description:
        "A coding interview assesses programming skills and problem-solving through technical challenges.",
      active: true,
      company: true,
      icon: <FaCode />,
    },
    // {
    //   img: <RiRobot2Line />,
    //   title: "English Practice Bot",
    //   id: 6, // interview id
    //   sort: 8,
    //   description:
    //     "English Practice Bot helps improve speaking skills by asking questions, providing feedback on your answers.",
    //   active: true,
    //   icon: <VscHubot className="w-14 h-14" />,
    // },
    {
      img: <MdOutlineQuestionAnswer />,
      title: "Viva Interview",
      id: 9, // interview id
      sort: 7,
      description:
        "The company's interview process efficiently assesses skills and cultural fit through diverse formats.",
      active: true,
      icon: <SlSpeech />,
    },
    {
      img: <AiOutlineReconciliation />,
      title: "MCQ's Test",
      id: "mcq", // interview id
      sort: 9,
      description:
        "An online MCQ test assesses cognitive abilities, problem-solving skills, and technical knowledge through a series of multiple-choice questions.",
      active: true,
      icon: <AiOutlineReconciliation />,
    },
    {
      img: <ImSortAmountAsc />,
      title: "Resume Analyzer",
      id: "resumeSort", // interview id
      sort: 10,
      description:
        "A resume analyzer scans and evaluates resumes to match key skills and qualifications with job requirements.",
      active: true,
      icon: <ImSortAmountAsc />,
    },
  ];

  const [filteredList, setFilteredList] = useState(freeInterviews);

  const { UserStore } = useStores();

  useEffect(() => {
    const showThisPage = view("home");
    if (!showThisPage) {
      navigate("/dashboard/jobinternship");
    }
  }, []);

  useEffect(() => {
    const userAgentData = navigator.userAgentData;
    if (userAgentData && userAgentData.brands) {
      const isChrome = userAgentData.brands.some(
        (brand) => brand.brand === "Google Chrome",
      );
      setIsNotChrome(!isChrome);
    }
    UserStore.getRankers();
  }, []);

  const [showprogress, setShowProgress] = useState(true);

  const getProgress = () => {
    const user = JSON.parse(localStorage.getItem("user")) || {};

    // Ensure dob is a string before trimming
    const basic =
      user.name?.trim().length > 0 &&
      String(user.dob || "").trim().length > 0 && // Convert to string safely
      user.gender?.trim().length > 0 &&
      user.bio?.trim().length > 0 &&
      (typeof user.resume === "string" ? user.resume.trim().length > 0 : false); // Checking resume

    const skills = Array.isArray(user.skills) && user.skills.length > 0;

    const contact = user?.linkedIn?.trim().length > 0 && user?.mobile;

    const experience =
      (Array.isArray(user.previousCompanies) &&
        user.previousCompanies.length > 0) ||
      (user.currentCompany && user.currentCompany.trim().length > 0);

    let data = [
      {
        label: "Basic Details",
        completed: basic,
        label2: "Basic Details",
        show: true,
      },

      {
        label: "Contact Details",
        completed: contact,
        label2: "Contact Details",
        show: true,
      },
      {
        label: "Experience",
        completed: experience,
        label2: "Experience",
        show: true,
      },
      {
        label: "Skills",
        completed: skills,
        label2: "Skills",
        show: true,
      },
    ];

    console.log(data);
    return data;
  };

  const calculateCompletionPercentage = () => {
    const data = getProgress();
    const totalItems = data.length;
    const completedItems = data.filter((item) => item.completed).length;
    const percentage = (completedItems / totalItems) * 100;
    if (percentage === 100) {
      setShowProgress(false);
    }
    return percentage.toFixed(0);
  };

  return (
    <Observer>
      {() => (
        <>
          {PopupStore.referAndEarn && (
            <ReferAndEarn
              popUpInitialValue={PopupStore.referAndEarn}
              handlePopup={() => {
                PopupStore.setReferAndEarn(false);
              }}
            />
          )}
          {PopupStore.topicbasedinterview && (
            <TopicBasedInterview
              popUpInitialValue={PopupStore.topicbasedinterview}
              handlePopup={() => {
                PopupStore.setTopicBasedInterview(false);
              }}
            />
          )}
          {PopupStore.createinterview && (
            <Create
              popUpInitialValue={PopupStore.createinterview}
              handlePopup={() => {
                PopupStore.setCreateInterview(false);
              }}
            />
          )}

          {PopupStore.companyBasedInterview && (
            <CompanyBasedInnterview
              popUpInitialValue={PopupStore.companyBasedInterview}
              handlePopup={() => {
                PopupStore.setCompanyBasedInterview(false);
              }}
            />
          )}
          {PopupStore.KnowMore && (
            <KnowMore
              popUpInitialValue={PopupStore.KnowMore}
              handlePopup={() => {
                PopupStore.setKnowMore(false);
              }}
            />
          )}

          {PopupStore.getMoreCredits && (
            <GetMoreCreditsPopUp
              popUpInitialValue={PopupStore.getMoreCredits}
              handlePopup={() => {
                PopupStore.setGetMoreCredits(false);
              }}
              referAndEarnHide={true}
            />
          )}
          {PopupStore.mobileVerfication && (
            <MobileVerification
              popUpInitialValue={true}
              handlePopup={() => {
                PopupStore.setMobileVerfication(false);
              }}
            />
          )}
          {PopupStore.redeemCoupon && (
            <RedeemCoupon
              popUpInitialValue={true}
              handlePopup={() => {
                PopupStore.setRedeemCoupon(false);
              }}
            />
          )}

          {PopupStore.paymentGateway && (
            <PurchaseCredits
              gateWay="phonePe"
              onClose={() => {
                PopupStore.setPaymentGateway(false);
              }}
            />
          )}
          {PopupStore.facingProblem && (
            <FacingProblem
              popUpInitialValue={PopupStore.facingProblem}
              image={eerorImage}
              closeThisPopUP={() => {
                PopupStore.setFaccingProblem(false);
              }}
            />
          )}
          <div className="flex md:hidden lg:hidden flex-col justify-center items-center w-[100vw]  gil-reg">
            <MobileBottomNavBar />
          </div>
          <div className="w-[100%] lg:w-[98%] lg:flex md:flex flex-col  ">
            {/* {CommonStore.showBrowserWarning && isNotChrome && (
              <div className="h-[6rem] px-2 bg-slate-100">
                <WarningCardBrowswer />
              </div>
            )} */}
            {showNewUi ? (
              <div className="">
                {/* this is the updated new ui */}

                {/* <SearchBar
                  value="Search by course"
                  isDashboard={true}
                  heading="Home Page"
                  notificationIcon={<MdNotifications className="text-3xl" />}
                  searchPlaceHolder="Search by Role or Technology coming soon"
                  buttonText="Create Interview"
                ></SearchBar> */}
                <div className="mt-3 w-[93%] mx-auto">
                  <ResponsiveHeader
                    title={"Home Page"}
                    showButton={false}
                    showDropdown={false}
                    handleInputChange={(event) => {
                      const searchValue = event.target.value.toLowerCase(); // Get the input value
                      const filteredData = freeInterviews.filter((interview) =>
                        interview.title.toLowerCase().includes(searchValue),
                      );
                      setFilteredList(filteredData); // Update the state

                      // Logging inside useEffect ensures it logs after state updates
                      console.log("Filtered List:", filteredData);
                    }}
                  />
                </div>

                {/* <Carousel /> */}
                <div className="w-[93%] mx-auto ">
                  <div className="w-full flex justify-between items-center">
                    {/* <FreeInterviews completed={5} total={5} /> */}
                  </div>
                  {/* <div className="bg-primary h-fit mb-12 w-full relative flex px-10 gap-16 justify-between items-center text-white mx-auto rounded-xl">
                    <img src={JobFairIcon} alt="Job Fair Icon" className="h-72 absolute object-contain " />
                    <div className="md:w-[50%] lg:w-[35%]">

                    </div>
                      <div className="w-full h-full flex flex-col justify-between py-5 gap-2">
                      <div className="flex text-start gap-2 flex-col my-3">
                      <div>
                      <h1 className="text-3xl font-semibold mr-2">AI- Powered Online Job Fair   </h1>
                      </div>
                      <p className="font-bold text-xs h-full mt-1 ">Join our AI-Powered Online Job Fair and take the next step towards landing your dream job. This unique virtual event harnesses advanced AI technologies to match you with recruiters and hiring managers from leading companies.

</p>
                      </div>
                      <button onClick={() => {
                        UserStore.setTermsAndConditionsPopup(true);
                      }} className="text-primary bg-white px-12 w-fit rounded-xl flex items-center justify-center mt-2 py-3"> <p className="font-semibold text-xl "> Register Now </p> </button>
                      </div>
                  </div> */}
                  <TermsAndConditionsPopup />
                  {/* <div className="w-full">
                    <TopCandidates />
                  </div> */}
                </div>
                {showprogress && (
                  <div className="w-[100%] md:w-[93%] mx-auto mt-5">
                    <ProgressBar
                      steps={getProgress()}
                      percentage={calculateCompletionPercentage()}
                      buttonName="Complete Profile"
                      buttonAction={() => {
                        navigate("/dashboard/settings");
                      }}
                      commingFrom="profile"
                      description="Complete your profile to unlock full functionality and enhance your career opportunities."
                      closeIcon={
                        <AiOutlineClose className="text-white text-md p-[0.08rem]  rounded-full cursor-pointer bg-primary" />
                      }
                      onClose={() => setShowProgress(false)}
                    />
                  </div>
                )}
                <div className="w-[93%] mx-auto ">
                  <div className="w-full flex justify-between items-center -ml-1">
                    <p className="font-semibold md:text-xl lg:text-3xl text-primary mt-2 md:mt-8">
                      Services We Offer
                    </p>
                    {/* <FreeInterviews completed={5} total={5} /> */}
                  </div>
                  <div className="w-full">
                    <InterviewList freeInterviews={filteredList} />
                  </div>
                </div>
              </div>
            ) : (
              <div className="gil-reg  w-[98%] mx-auto flex py-2   flex-col-reverse lg:flex-row md:flex-row justify-between text-[#021D7B] font-[400]">
                <div className="bg-bg3 w-[75%] py-auto   rounded-[10px] my-auto mt-[20px] ">
                  {/* <div className=" h-[50vh] w-[90%]  mt-7  pb-[200px]  "> */}
                  <UserDetails />

                  {/* </div> */}
                  <EnrolledCourses
                    onClickEmptyEnroll={() => {
                      navigate("/dashboard/learn");
                    }}
                  />

                  {/* <PreviousMeetingDetails /> */}
                  {<Report />}
                </div>
                {/*  */}

                <div className="flex flex-col  lg:mx-0 md:mx-0 mx-auto mt-[1.8%] w-[30%] ">
                  {/* <CreditPoints availableCredits={availableCredits} /> */}

                  <MeetingCreationForm />
                  <ReferAndEarnCard />
                  <div className="flex mt-10 flex-row items-center justify-between w-[90%] mx-auto">
                    <p className="font-bold text-text_color3 text-[15px]">
                      Recent Interviews
                    </p>

                    {TotalInterviews()}
                  </div>

                  <PreviousInterview />
                </div>
              </div>
            )}
            <HelpCenter />
          </div>
        </>
      )}
    </Observer>
  );
}

export function AdditionalSettings({ fromTechnical, fromHR }) {
  const { InterviewStore, RecuiterStore } = useStores();
  const [show, setShow] = useState(false);

  const [camera, setCamera] = useState(false);
  const [resume, setResume] = useState(false);
  const [screen, setScreen] = useState(false);
  const [whoPayCheck, setWhoPayCheck] = useState(false);
  const [whoPay, setWhoPay] = useState("");

  useEffect(() => {
    if (fromTechnical) {
      setCamera(
        RecuiterStore.jobPostDetails.technicalInterviewDetails
          .additionalSettings.camera,
      );
      setResume(
        RecuiterStore.jobPostDetails.technicalInterviewDetails
          .additionalSettings.resume,
      );
      setScreen(
        RecuiterStore.jobPostDetails.technicalInterviewDetails
          .additionalSettings.screen,
      );
      setWhoPayCheck(
        RecuiterStore.jobPostDetails.technicalInterviewDetails.whoPayCheck,
      );
      console.log(
        RecuiterStore.jobPostDetails.technicalInterviewDetails.whoPayCheck,
        "sai",
      );
    } else if (fromHR) {
      setCamera(
        RecuiterStore.jobPostDetails.hrInterviewDetails.additionalSettings
          .camera,
      );
      setResume(
        RecuiterStore.jobPostDetails.hrInterviewDetails.additionalSettings
          .resume,
      );
      setScreen(
        RecuiterStore.jobPostDetails.hrInterviewDetails.additionalSettings
          .screen,
      );
      setWhoPayCheck(
        RecuiterStore.jobPostDetails.hrInterviewDetails.whoPayCheck,
      );
    } else {
      setCamera(InterviewStore.additionalSettings.camera);
      setResume(InterviewStore.additionalSettings.resume);
      setScreen(InterviewStore.additionalSettings.screen);
    }
    // alert(RecuiterStore.jobPostDetails.hrInterviewDetails.whoPay, RecuiterStore.jobPostDetails.technicalInterviewDetails.whoPay)
  }, [fromTechnical, fromHR, RecuiterStore, InterviewStore]);

  useEffect(() => {
    console.log(
      "sai",
      RecuiterStore.jobPostDetails.technicalInterviewDetails.whoPayCheck,
    );
  }, [RecuiterStore.jobPostDetails.technicalInterviewDetails.whoPayCheck]);

  const settingVideo = (e) => {
    const value = e.target.checked;
    setCamera(value);
    if (fromTechnical) {
      RecuiterStore.settechnicalAdditionalSettings("camera", value);
    } else if (fromHR) {
      RecuiterStore.sethrAdditionalSettings("camera", value);
    } else {
      InterviewStore.setAdditionalSettings("camera", value);
    }
  };

  const settingResume = (e) => {
    const value = e.target.checked;
    setResume(value);
    if (fromTechnical) {
      return RecuiterStore.settechnicalAdditionalSettings(
        "resume",
        e.target.checked,
      );
    } else if (fromHR) {
      return RecuiterStore.sethrAdditionalSettings("resume", e.target.checked);
    } else {
      return InterviewStore.setAdditionalSettings("resume", e.target.checked);
    }
  };

  const settingScreen = (e) => {
    const value = e.target.checked;
    setScreen(value);
    if (fromTechnical) {
      return RecuiterStore.settechnicalAdditionalSettings(
        "screen",
        e.target.checked,
      );
    } else if (fromHR) {
      return RecuiterStore.sethrAdditionalSettings("screen", e.target.checked);
    } else {
      return InterviewStore.setAdditionalSettings("screen", e.target.checked);
    }
  };

  const settingWhoPay = (e) => {
    if (!whoPayCheck) {
      const value = e.target.checked;
      const userConfirmed = window.confirm(
        "If the candidate does not have the money, the interview is not taken",
      );
      if (userConfirmed) {
        setWhoPayCheck(value);
        setWhoPay("candidate");
        if (fromTechnical) {
          RecuiterStore.setTechnicalInterviewDetails("whoPayCheck", value);
        } else if (fromHR) {
          RecuiterStore.setHrInterviewDetails("whoPayCheck", value);
        } else {
          return InterviewStore.setWhoPayValue(whoPay ?? "candidate");
        }
      } else {
        setWhoPay("company");
        if (fromTechnical) {
          RecuiterStore.setTechnicalInterviewDetails("whoPayCheck", value);
        } else if (fromHR) {
          RecuiterStore.setHrInterviewDetails("whoPayCheck", value);
        } else {
          return InterviewStore.setWhoPayValue(whoPay);
        }
      }
    } else {
      const value = e.target.checked;
      if (fromTechnical) {
        RecuiterStore.setTechnicalInterviewDetails("whoPayCheck", value);
      } else if (fromHR) {
        RecuiterStore.setHrInterviewDetails("whoPayCheck", value);
      } else {
        return InterviewStore.setWhoPayValue(whoPay ?? "candidate");
      }
      setWhoPayCheck(value);
    }
  };

  return (
    <div
      className={`flex flex-col justify-center cursor-pointer my-4 border border-primary ${
        fromTechnical ? "w-full" : "w-full"
      } min-h-[40px] md:min-h-[45px] md:text-lg rounded-xl lg:text-xl p-2`}
    >
      <div
        className="flex flex-row w-full  px-2 justify-between items-center"
        onClick={() => {
          setShow(!show);
        }}
      >
        <p className="text-lg ">Additional Settings</p>
        {!show ? (
          <IoIosArrowDown className="text-sm text-primary cursor-pointer" />
        ) : (
          <IoIosArrowUp className="text-sm text-primary cursor-pointer" />
        )}
      </div>
      {show && (
        <div className="px-4 flex flex-col gap-2 py-2">
          <span className="flex justify-between items-center">
            <span className="text-base">Video </span>
            <label className="switch">
              <input
                type="checkbox"
                checked={camera}
                onChange={settingVideo}
                name="cam"
                id="cam"
              />
              <span className="slider round"></span>
            </label>
          </span>
          <span className="flex justify-between items-center">
            <span className="text-base">Resume </span>
            <label className="switch">
              <input
                type="checkbox"
                checked={resume}
                name="resume"
                id="resume"
                onChange={settingResume}
              />
              <span className="slider round"></span>
            </label>
          </span>
          <span className="flex justify-between items-center">
            <span className="text-base">Screen Recording </span>
            <label className="switch">
              <input
                type="checkbox"
                checked={screen}
                name="screen"
                id="screen"
                onChange={settingScreen}
              />
              <span className="slider round"></span>
            </label>
          </span>
          <span className="flex justify-between items-center">
            <span className="text-base">Candidate Pay for this Interview </span>
            <label className="switch">
              <input
                type="checkbox"
                checked={whoPayCheck}
                name="whoPay"
                id="whoPay"
                onChange={settingWhoPay}
              />
              <span className="slider round"></span>
            </label>
          </span>
        </div>
      )}
    </div>
  );
}

export function CustomQuestionForm() {
  const { InterviewStore } = useStores();
  const [questions, setQuestions] = useState([]);
  const hobbyRef = useRef(null);

  const handleAddQuestion = () => {
    setQuestions([...questions, ""]);
  };

  const handleRemoveQuestion = (index) => {
    setQuestions(questions.filter((_, i) => i !== index));
  };

  const handleQuestionChange = (index, value) => {
    const newQuestions = [...questions];
    newQuestions[index] = value;
    setQuestions(newQuestions);
    console.log(newQuestions);
  };

  useEffect(() => {
    InterviewStore.setCustomQuestions(questions);
  }, [questions]);

  return (
    <Observer>
      {() => (
        <>
          <div className="flex justify-between items-center px-2 pr-5 ">
            <p className="block mb-2  w-full font-medium ml-0">
              Add custom questions
            </p>
            <IoInformationCircleOutline className="text-2xl text-primary" />
          </div>

          {questions.map((question, index) => (
            <div key={index} className="mb-4 w-full">
              <div className="flex">
                <input
                  type="text"
                  value={question}
                  onChange={(e) => handleQuestionChange(index, e.target.value)}
                  className="px-2 text-primary border-b-2 border-border2 w-full h-[30px] focus:outline-none "
                  placeholder="Enter your question"
                />
                <MdDeleteOutline
                  onClick={() => handleRemoveQuestion(index)}
                  className="text-xl cursor-pointer mt-1 ml-2 text-text_color5"
                />
              </div>
            </div>
          ))}
          <button
            onClick={handleAddQuestion}
            type="button"
            className="text-primary w-full my-3 flex items-center mt-1"
          >
            <FaPlus className="mr-1" />
            {questions.length > 0 ? " Add one more question" : " Add Question"}
          </button>
        </>
      )}
    </Observer>
  );
}
export function TotalInterviews() {
  const { UserStore } = useStores();
  return (
    <div className="flex flex-row w-fit ">
      <p className="text-sm text-black pt-2">Total Interviews</p>
      <p className="text-primary text-3xl px-2 ">
        {UserStore?.dashboardInterviews?.length}
      </p>
    </div>
  );
}

export function MeetingCreationForm({
  showMeeting = false,
  fromCompany,
  takeInterview = false,
}) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
  const { applicationId } = useParams();
  const [selectedFileName, setSelectedFileName] = useState(null);
  const [selectedFileByUser, setSelectFileByUser] = useState(null);
  const { InterviewStore, PopupStore, RecuiterStore, UserStore } = useStores();
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const studentDetails = JSON.parse(localStorage.getItem("user_google"));
  const [name, setName] = useState(studentDetails?.name ?? "");
  const [technology, setTechnology] = useState("");
  const [restrict, setRestrict] = useState(false);
  const [noOfQuestions, setnoOfQuestions] = useState(5);
  const [level, setLevel] = useState("low");
  const [showMeetingForm, setShowMeetingForm] = useState(showMeeting);
  const [role, setRole] = useState("");
  const [company, setCompany] = useState("");
  const [title, settitle] = useState("");
  const [invitationLink, setInvitationLink] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const [wantToUploadResume, setWantToUploadResume] = useState(true); // this is used to highlight the options
  const [attempts, setAttempts] = useState(-1);
  const [count, setCount] = useState(0);
  const [whoPay, setWhoPay] = useState("");

  const StudentOriginalName = JSON.parse(localStorage.getItem("user"));

  const fetchData = async (pdfFile) => {
    try {
      const response = await axios.get(pdfFile, {
        responseType: "arraybuffer",
      });

      const pdfData = response.data; // Directly use response.data as array buffer

      const pdf = await pdfjs.getDocument({ data: pdfData }).promise;
      let fullText = "";

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const content = await page.getTextContent();
        const pageText = content.items.map((item) => item.str).join("\n");
        fullText += pageText + "\n";
      }

      // setExtractedText(fullText);
      console.log(fullText);
      InterviewStore.setResumeText(fullText);
    } catch (error) {
      console.error("Error fetching or parsing PDF file", error);
    }
  };
  useEffect(() => {
    const customSettings = JSON.parse(localStorage.getItem("customSettings"));
    try {
      setAttempts(customSettings[3].value);
    } catch (error) {}
    const presentIteview = JSON.parse(localStorage.getItem("presentIteview"));
    setWhoPay(presentIteview?.whoPay);
  }, []);

  // const [disableForm, setDisableForm] = useState(showMeetingForm);

  const handlechangeName = (e) => {
    setName(e.target.value);
  };
  const handlechangeTechnology = (e) => {
    setTechnology(e.target.value);
  };
  const handlechangeRole = (e) => {
    setRole(e.target.value);
    console.log(role);
  };
  const handlechangeCompany = (e) => {
    setCompany(e.target.value);
    console.log(company);
  };

  // const handlechangelevel = (e) => {
  //   if (e.target.value === "1") setLevel("low");
  //   else if (e.target.value === "2") setLevel("medium");
  //   else if (e.target.value === "3") setLevel("high");
  //   else setLevel("low");
  // };

  const OpenInterviewScreenBySendingParams = async (e) => {
    e.preventDefault();
    localStorage.removeItem("career");
    console.log(InterviewStore.resumeText);

    const nameValid = /^[A-Za-z\s]*$/.test(name);

    if (!nameValid) {
      return alert("Name should be in alphabets only.");
    }

    if (InterviewStore.showResume && InterviewStore.resumeFile === null) {
      return alert("Please upload your resume");
    }

    const user = JSON.parse(localStorage.getItem("user"));

    if (!whoPay === "company" && user.coins < 179) {
      alert(
        "You don't have enough credits to start the interview, Please Purchase Interview / Credits",
      );
      PopupStore.setGetMoreCredits(true);
      return;
    }

    try {
      function searchNameInResumeText() {
        // Split the name by spaces to get an array of name parts

        const nameParts = name.split(" ").filter((part) => part.trim() !== "");
        // Check if any of the name parts are included in the InterviewStore.resumeText string
        const isNameFound = nameParts.some((part) =>
          InterviewStore.resumeText.includes(part),
        );
        console.log(nameParts);

        return isNameFound;
      }
      if (wantToUploadResume) {
        console.log(searchNameInResumeText());
        if (!searchNameInResumeText() && count < 2) {
          console.log(count);
          alert("Your Name in the Resume should match with the entered name");
          return setCount(count + 1);
        }
        if (!searchNameInResumeText() && count === 2)
          if (
            window.confirm(
              "Your Name in the Resume didn't match with the entered name.Do you want to continue any way?",
            )
          ) {
            console.log(count);
          } else {
            return;
          }
      } // Do something with the matched resumes
    } catch (error) {
      console.error("Error processing interview screen parameters:", error);
    }

    let resumeLink = null;

    const userDetails = UserStore.userDetails;
    let response = null;
    try {
      const customSettings = JSON.parse(localStorage.getItem("customSettings"));
      const id = JSON.parse(localStorage.getItem("interviewId"));
      console.log(userDetails);
      console.log(id);
      const body = {
        userId: userDetails._id,
        attempts: customSettings[3].value,
        invitationFrom: id,
      };
      setAttempts(customSettings[3].value);
      response = await apiPostPut(
        body,
        "/interview/validate-custom-settings",
        "POST",
      );
      console.log("validation", response);
    } catch (error) {}

    if (localStorage.getItem("user") === null) {
      return PopupStore.setLoginWarning(true);
    }

    if (takeInterview === true) {
      // check resume uploaded or not for resume based interview for user or students
      setWaiting(true);
      const idOfResumeBasedInterviews = [2, 4, 8];
      if (
        idOfResumeBasedInterviews.includes(
          InterviewStore.interviewSettings?.id ??
            InterviewStore.interviewSettings?.interviewId,
        )
      ) {
        if (InterviewStore.resumeFile === null && wantToUploadResume) {
          setWaiting(false);
          return alert("Please upload your resume");
        }

        const resumeFileName = Date.now() + InterviewStore.resumeFile?.name;

        const resumeUploadResponse = await uploadFileToAzure(
          resumeFileName,
          InterviewStore.resumeFile,
          { action: "interview" },
        );
        if (resumeUploadResponse?.success) {
          resumeLink = resumeUploadResponse?.url;
        }
      }
      setWaiting(false);
    }

    let interviewDetails = {
      name: name,
      technology: technology,
      levelOfInterview: level === "" ? "low" : level,
      noOfQuestions: noOfQuestions,
      role: role,
      company: company,
      customQuestions: InterviewStore.customQuestions,
      whoPay: InterviewStore.interviewDetails.whoPay,
      // resume: InterviewStore.resumeFile,
      resume: InterviewStore.resumeText,
    };
    if (InterviewStore.companyInterview) {
      console.log("companyInterview", InterviewStore.additionalSettings);
      interviewDetails.customSettings = [
        {
          name: "video",
          value: InterviewStore.additionalSettings.camera,
        },
        {
          name: "resume",
          value: InterviewStore.additionalSettings.resume,
        },
        {
          name: "screen",
          value: InterviewStore.additionalSettings.screen,
        },
        {
          name: "attempts",
          value: InterviewStore.additionalSettings.attempts,
        },
      ];
      console.log("hello", interviewDetails);
    }
    if (resumeLink !== null) {
      interviewDetails["resumeLink"] = resumeLink;
    }

    // the below code is interview invitation creation

    if (takeInterview === false) {
      if (
        userDetails?.role?.role === "company" ||
        userDetails?.role?.role === "consultancy"
      ) {
        // InterviewStore.changeInterviewIdByIdForResume(
        //   InterviewStore.interviewSettings?.id
        // );
        interviewDetails["interviewer"] = userDetails?._id;
        interviewDetails["interviewType"] = "real";
        InterviewStore.updateInterviewDetails(interviewDetails);

        let body = {
          ...InterviewStore.interviewSettings,
          isInvitation: true,
        };

        delete body.id;
        if (RecuiterStore.clientId) {
          body.client = RecuiterStore.clientId;
        }

        console.log(body);

        setWaiting(true);
        const apiResponse = await createInterview(body);
        setWaiting(false);
        console.log(apiResponse);
        if (
          (apiResponse?.status === 200 || apiResponse?.status === 201) &&
          apiResponse?.body?.success
        ) {
          alert("Invitation sent successfully");

          const data = apiResponse.body?.data;
          console.log(data?.interviewLink);
          setInvitationLink(data?.interviewLink ?? data?._id);
        } else {
          alert("Something went wrong");
        }

        return;
      }
    }

    // end of invitation creation

    // localStorage.setItem("interviewDetails", JSON.stringify(interviewDetails));
    InterviewStore.updateInterviewDetails(interviewDetails);
    console.log(InterviewStore.interviewDetails);
    // navigate(
    //   `/interview?name=${name}&technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}`
    // );
    // Construct the new URL

    // Step 1: Access the current URL's query string
    const queryString = window.location.search;

    // Step 2: Use URLSearchParams to parse the query string
    const urlParams = new URLSearchParams(queryString);

    // Step 3: Extract the applicationId
    const application = urlParams.get("applicationId");

    // Now you can use applicationId as needed
    console.log(applicationId); // For demonstration

    const newURL = application
      ? `/interview?name=${name}&technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}&applicationId=${application}`
      : `/interview?name=${name}&technology=${technology}&level=${level}&question=${noOfQuestions}&id=${InterviewStore.interviewSettings?.id}`;

    // Set the new URL and trigger a reload
    console.log(response);
    console.log(InterviewStore.companyInterview, "companyInterview");

    if (!whoPay === "company" && user.coins < 179) {
      alert(
        "You don't have enough credits to start the interview, Please Purchase Interview / Credits",
      );
      PopupStore.setGetMoreCredits(true);
      return;
    }

    if (!InterviewStore.validation) {
      window.location.href = newURL;
      return;
    }
    if (whoPay === "candidate") {
      const user = JSON.parse(localStorage.getItem("user"));
      const coins = user?.coins;
      if (coins > 58) {
        alert("You have to pay for Interview");
      } else {
        const userConfirmed = window.confirm(
          "You have to pay ₹99 for this assessment.",
        );

        if (userConfirmed) {
          // If the user clicks "OK"
          return InterviewStore.setWhoPay(true);
        } else {
          // If the user clicks "Cancel"
          return console.log("User chose not to proceed with the payment.");
        }
      }
    }
    if (response?.status === 200) {
      let interviewSettings = JSON.parse(
        localStorage.getItem("interviewSettings"),
      ); // Parse the JSON string
      console.log(interviewSettings, "interviewSettings");

      interviewSettings = {
        ...interviewSettings,
        whoPay: whoPay, // Add the whoPay property
      };

      // alert(JSON.stringify(interviewSettings));
      localStorage.setItem(
        "interviewSettings",
        JSON.stringify(interviewSettings),
      );
      window.location.href = newURL;
    } else {
      if (localStorage.getItem("user") === null) {
        window.location.href = newURL;
      } else {
        alert(response?.body?.message);
      }
    }
  };

  const handleModal = () => {
    InterviewStore.setInterviewModal(3);
    // console.log(InterviewStore.interviewModal);
    alert("  ");
    // console.log(JSON.parse(localStorage.getItem("interviewSettings")));
    let interviewSettings = JSON.parse(
      localStorage.getItem("interviewSettings"),
    );
    interviewSettings.model = 3;
    // console.log(interviewSettings);
    localStorage.setItem(
      "interviewSettings",
      JSON.stringify(interviewSettings),
    );
  };
  const handleFileChange = (event) => {
    const selectedFile = event.currentTarget.files[0];

    if (selectedFile) {
      InterviewStore.setResumeFile(selectedFile);
      const fileURL = URL.createObjectURL(selectedFile);
      fetchData(fileURL);
      // const { name } = selectedFile;
      // setSelectedFileName(name); // Update the state with the filename
      // setSelectFileByUser(selectedFile);
    }
  };

  const enableFieldByRole = () => {
    const role = getUserRoleFromLocalStorage();

    console.log(role);

    if (role === null) return;

    InterviewStore.enableInterviewFormById(
      InterviewStore.interviewSettings?.id ??
        InterviewStore?.interviewSettings?.interviewId,
      role,
    );

    switch (role) {
      case "company":
      case "consultancy":
        console.log(InterviewStore.interviewSettings?.id);
        InterviewStore.setShowCustomQuestions();
        // InterviewStore.changeInterviewIdByIdForResume(
        //   InterviewStore.interviewSettings?.id
        // ); // this will enable resume based interview by default

        break;

      default:
        break;
    }
  };
  const location = useLocation();
  const autoFillSomeFields = () => {
    const queryParams = new URLSearchParams(location.search);
    const meetingId = queryParams.get("meetingid");
    if (meetingId) {
      setRestrict(true);
    }
    // alert("Please fill the form to start the interview");

    setnoOfQuestions(
      InterviewStore.interviewSettings?.noOfQuestions ?? noOfQuestions,
    );
    setLevel(InterviewStore.interviewSettings?.levelOfInterview ?? level);
    setTechnology(InterviewStore.interviewSettings?.technology ?? technology);
  };

  const consoleMobxFields = () => {
    console.log(InterviewStore.showTechnology);
    console.log(InterviewStore.showName);
    console.log(InterviewStore.showInterviewLevel);
    console.log(InterviewStore.showNoOfQuestions);
  };

  useEffect(() => {
    console.log("form opened 💥", InterviewStore.interviewSettings.interviewId);

    enableFieldByRole();
    autoFillSomeFields();
    consoleMobxFields(); // remove this later

    return () => {
      InterviewStore.resetInterviewFields();
    };
  }, []);

  useEffect(() => {
    console.log("Selected file name:", selectedFileName);
    console.log(selectedFileByUser);
  }, [selectedFileName]); // This effect runs when selectedFileName changes

  const attachResume = (value) => {
    setWantToUploadResume(value);
    InterviewStore.setShowResume(value);
    InterviewStore.changeInterviewIdByIdForResume(
      InterviewStore.interviewSettings?.id,
    );
  };
  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = invitationLink;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
    window.alert("link copied");
  };

  const getInterviewDescription = () => {
    const interviewId = InterviewStore.interviewSettings?.interviewId;
    if (interviewId < 10) {
      const interview = interviewsList.find(
        (interview) => interview?.id === interviewId,
      );
      if (interview) {
        settitle(interview?.title);
        return interview?.description;
      }
    } else {
      const prointerview = interviewsProList.find(
        (interview) => interview?.id === interviewId,
      );
      if (prointerview) {
        settitle(prointerview?.title);
        return prointerview?.description;
      }
    }
  };

  const handleCompanyInterview = () => {
    navigate("/dashboard/dashboard");
  };
  const redirectToSignupPageWithCurrentUrl = () => {
    const currentPath = window.location.href;

    // set currentPath in local storage
    setDataToLocalStorage("redirectUrl", currentPath);

    const signupUrl = `/`;

    console.log(signupUrl);

    navigate(signupUrl);
  };

  return (
    <Observer>
      {() => (
        <div>
          {PopupStore.loginWarning && (
            <Popup
              popUpInitialValue={PopupStore.loginWarning}
              handlePopup={() => {
                PopupStore.setLoginWarning(false);
              }}
              image={loginWarningImage}
              content="Please signup to start interview"
              buttontext="Signup now"
              onClick={() => {
                redirectToSignupPageWithCurrentUrl();
                PopupStore.setLoginWarning(false);
              }}
            />
          )}
          <GetMoreCreditsPopUp
            popUpInitialValue={InterviewStore.whoPay}
            handlePopup={() => {
              InterviewStore.setWhoPay(false);
            }}
            whoPay={true}
          />
          {PopupStore.redeemCoupon && (
            <RedeemCoupon
              popUpInitialValue={true}
              handlePopup={() => {
                PopupStore.setRedeemCoupon(false);
              }}
            />
          )}

          {PopupStore.paymentGateway && (
            <PurchaseCredits
              gateWay="phonePe"
              onClose={() => {
                PopupStore.setPaymentGateway(false);
              }}
            />
          )}
          {PopupStore.createinterview && (
            <Create
              popUpInitialValue={PopupStore.createinterview}
              handlePopup={() => {
                PopupStore.setCreateInterview(false);
              }}
            />
          )}
          {
            showMeetingForm ? (
              <div
                className={`bg-bg3  md:px-10 lg:px-10 px-0  flex flex-col diamond-gradient lg:w-[90vw] md:w-[90vw] w-[100vw] rounded-[50px] md:h-[95vh] lg:h-[95vh] justify-center md:ml-[-95%] lg:ml-[-95%] lg:mt-0 md:mt-0 mt-[300px] transition-transform duration-1000 ease-in-out overflow-y-hidden overflow-x-hidden `}
              >
                <div className="flex flex-col md:flex-row lg:flex-row justify-around">
                  <div className="pl-2 pt-10 md:p-10 flex flex-col w-[90%] md:w-[50%]">
                    <button
                      className="flex items-center text-primary font-semibold gap-2 text-2xl md:text-3xl  cursor-pointer absolute right-[6%] md:top-[6%] lg:top-[7%]"
                      onClick={() => {
                        InterviewStore.setAdditionalSettings("camera", false);
                        InterviewStore.setAdditionalSettings("resume", false);
                        InterviewStore.setAdditionalSettings("screen", false);
                        InterviewStore.setAdditionalSettings("attempts", 2);
                        setShowMeetingForm(false);
                        PopupStore.setTopicBasedInterview(false);
                      }}
                    >
                      <AiOutlineCloseCircle />
                    </button>
                    <h1 className="text-2xl md:text-4xl font-extrabold md:mt-24 lg:mt-40 leading-[50px]">
                      Create a <br />
                      <span className="text-primary mt-0">
                        {InterviewStore.interviewSettings?.title ?? title}{" "}
                      </span>
                      {/* Interview Session */}
                    </h1>
                    <p className="text-base md:text-xl mt-5 md:mt-8">
                      {getInterviewDescription()}{" "}
                    </p>
                  </div>
                  <form
                    className="flex flex-col justify-center items-center relative md:w-[43%] lg:w-[40%] my-2 lg:ml-0 md:ml-0 ml-5 py-3 h-[100%]"
                    onSubmit={OpenInterviewScreenBySendingParams}
                  >
                    {/* <h1 className="text-center text-primary text-[30px]">Interview Creation</h1> */}
                    {/* <div className="mr-2 ml-auto ">
            <div className="w-6 h-6 text-lg text-bg3 m-auto cursor-pointer  rounded-full  bg-primary" >
              <p className="flex justify-center items-center  m-auto"><span className="m-auto">x</span></p>
            </div>
          </div> */}

                    {InterviewStore.showName && (
                      <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                        <label
                          htmlFor="name"
                          className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                        >
                          Candidate Name*
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          required
                          defaultValue={
                            StudentOriginalName?.name ||
                            UserStore?.userDetails?.name ||
                            studentDetails?.name
                          }
                          onChange={handlechangeName}
                          className="px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none "
                        />
                      </div>
                    )}
                    {InterviewStore.showTechnology && (
                      <div
                        className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                          InterviewStore.maskingFields.includes("technology")
                            ? "pointer-events-none"
                            : ""
                        }`}
                      >
                        <label
                          htmlFor="technology"
                          className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                        >
                          Topic of Interview (Technology)*
                        </label>
                        <input
                          type="text"
                          id="technology"
                          required
                          name="technology"
                          value={technology}
                          onChange={handlechangeTechnology}
                          className=" px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none "
                        />
                      </div>
                    )}

                    {InterviewStore.showNoOfQuestions && (
                      <div
                        className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                          InterviewStore.maskingFields.includes("noOfQuestions")
                            ? "pointer-events-none"
                            : ""
                        }`}
                      >
                        <label
                          htmlFor="technology"
                          className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                        >
                          Select No of questions
                        </label>
                        {!restrict ? (
                          <select
                            className=" px-5 py-3 rounded-xl w-[95%] h-[45px] md:h-[45px] md:text-lg lg:text-xl text-primary border text-center border-primary  focus:outline-none "
                            value={noOfQuestions}
                            onChange={(e) => setnoOfQuestions(e.target.value)}
                          >
                            <option defaultChecked={true} value={5}>
                              5 Questions
                            </option>
                            <option value={10}>10 Questions</option>
                            {noOfQuestions !== 5 && noOfQuestions !== 10 && (
                              <option value={noOfQuestions}>
                                {" "}
                                {noOfQuestions} Questions
                              </option>
                            )}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={noOfQuestions + " Questions"}
                            className="px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                          />
                        )}
                      </div>
                    )}

                    {InterviewStore.showCompany || InterviewStore.showRole ? (
                      <>
                        {InterviewStore.showCompany && (
                          <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                            <label
                              htmlFor="name"
                              className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                            >
                              Company
                            </label>
                            <input
                              onChange={handlechangeCompany}
                              required
                              type="text"
                              id="name"
                              name="name"
                              className="px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                            />
                          </div>
                        )}
                        {InterviewStore.showRole && (
                          <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                            <label
                              htmlFor="name"
                              className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                            >
                              Role
                            </label>
                            <input
                              onChange={handlechangeRole}
                              required
                              type="text"
                              id="name"
                              name="name"
                              className="px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                            />
                          </div>
                        )}
                      </>
                    ) : null}

                    {/* {InterviewStore.interviewSettings.id === 4 ? (
                  <div>
                    <div>
                      <div className="mb-4">
                        <label
                          htmlFor="name"
                          className="block  font-medium"
                        >
                          Company
                        </label>
                        <input
                          required
                          type="text"
                          id="name"
                          name="name"
                          onChange={handlechangeCompany}
                          className="px-2 text-primary border-b-2 border-border2  h-[30px] w-[300px] md:w-[300px] lg:w-[500px] focus:outline-none "
                        />
                      </div>
                    </div>
                    <div>
                      <div className="mb-4">
                        <label
                          htmlFor="name"
                          className="block  font-medium"
                        >
                          Role
                        </label>
                        <input
                          required
                          type="text"
                          id="name"
                          name="name"
                          onChange={handlechangeRole}
                          className="px-2 text-primary border-b-2 border-border2  h-[30px] w-[300px] md:w-[300px] lg:w-[500px] focus:outline-none "
                        />
                      </div>
                    </div>
                    <div className="flex flex-col items-center justify-center space-x-4">
                      <input
                        id="fileInput"
                        type="file"
                        className="hidden"
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="fileInput"
                        className="px-4 py-2 w-full flex justify-center items-center gap-3 text-center bg-primary text-white rounded-md cursor-pointer hover:bg-[#e67f34] transition duration-300 ease-in-out"
                      >
                        <MdFileUpload /> Upload Resume
                      </label>
                      <div className="flex flex-row w-full justify-between">
                        <p className="text-blue-500">
                          {InterviewStore.resumeFile?.name}
                        </p>
                        <p className="text-blue-500 cursor-pointer">Change</p>
                      </div>
                    </div>{" "}
                  </div>
                ) : null} */}
                    {InterviewStore.showInterviewLevel && (
                      <div
                        className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                          InterviewStore.maskingFields.includes(
                            "interviewLevel",
                          )
                            ? "pointer-events-none"
                            : ""
                        }`}
                      >
                        <label
                          htmlFor="level"
                          className="block mt-2 mb-1 ml-2 font-medium md:text-base lg:text-lg"
                          onDoubleClick={handleModal}
                        >
                          Select Level
                        </label>
                        {!restrict ? (
                          <select
                            className=" px-5 py-3 rounded-xl w-[95%] h-[45px] md:h-[45px] md:text-lg lg:text-xl text-primary border text-center border-primary  focus:outline-none "
                            value={level}
                            onChange={(e) => setLevel(e.target.value)}
                          >
                            <option defaultChecked={true} value="low">
                              Low
                            </option>
                            <option value="medium">Medium</option>
                            <option value="high">High</option>
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={level}
                            className="px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none"
                          />
                        )}

                        {/* <div className="flex flex-row w-full">
                          <button
                            type="button"
                            className={`${level === "low"
                              ? "bg-primary text-bg3"
                              : "bg-primary2 text-text_color3"
                              } w-[80px] px-5 py-2 rounded-[10.49px] text-center `}
                            onClick={() => setLevel("low")}
                          >
                            Low
                          </button>
                          <button
                            type="button"
                            className={`${level === "medium"
                              ? "bg-primary text-bg3"
                              : "bg-primary2 text-text_color3"
                              } w-[80px] px-2 py-2 rounded-[10.49px] ml-5 text-center`}
                            onClick={() => setLevel("medium")}
                          >
                            Medium
                          </button>

                          <button
                            type="button"
                            onClick={() => setLevel("high")}
                            className={`${level === "high"
                              ? "bg-primary text-bg3"
                              : "bg-primary2 text-text_color3"
                              } w-[80px] px-5 py-2 rounded-[10.49px] ml-5 text-center`}
                          >
                            High
                          </button>
                        </div> */}
                      </div>
                    )}
                    {InterviewStore.companyInterview && (
                      <div
                        className={`mb-2 w-full md:w-[70%] lg:w-[65%] ${
                          InterviewStore.maskingFields.includes("technology")
                            ? "pointer-events-none"
                            : ""
                        }`}
                      >
                        <label
                          htmlFor="technology"
                          className="block mb-1 md:mt-2 ml-2 font-medium md:text-base lg:text-lg"
                        >
                          No. of Attempts
                        </label>
                        <input
                          type="number"
                          id="technology"
                          required
                          name="technology"
                          value={InterviewStore.additionalSettings.attempts}
                          onChange={(e) => {
                            InterviewStore.setAdditionalSettings(
                              "attempts",
                              Number(e.target.value),
                            );
                          }}
                          className=" px-5 py-5 text-primary rounded-xl border border-primary w-[95%] h-[40px] md:h-[45px] md:text-lg lg:text-xl focus:outline-none "
                        />
                      </div>
                    )}
                    {InterviewStore.companyInterview && (
                      <div className=" mb-2 w-full md:w-[70%] lg:w-[65%]">
                        <AdditionalSettings />
                      </div>
                    )}
                    {InterviewStore.showCustomQuestions &&
                    InterviewStore.companyInterview ? (
                      <div className=" mb-2 w-full md:w-[70%] lg:w-[65%]">
                        <CustomQuestionForm />
                      </div>
                    ) : null}

                    {invitationLink !== null && (
                      <div className="flex w-full md:w-[70%] lg:w-[65%]">
                        <textarea
                          className="w-full h-[100px]"
                          value={invitationLink}
                        />
                        <span
                          class="flex text-gray-800 cursor-pointer w-5 h-5 hover:text-gray-400 duration-200"
                          onClick={handleCopyClick}
                        >
                          {" "}
                          <AiOutlineCopy className="text-xl active:text-primary" />
                        </span>
                      </div>
                    )}

                    {InterviewStore.askHaveResume &&
                      InterviewStore.ResumeCompanyInterview && (
                        <div
                          className={`mb-1 md:mt-2 w-[100%] pr-5 flex flex-row items-center justify-between md:w-[70%] lg:w-[65%] ${
                            InterviewStore.maskingFields.includes(
                              "askHaveResume",
                            )
                              ? ""
                              : ""
                          }`}
                        >
                          <label
                            htmlFor="level"
                            className="block text-center items-center md:ml-2 font-medium md:text-base lg:text-lg"
                            // onDoubleClick={handleModal}
                          >
                            Do you have a Resume?
                          </label>

                          <div className="flex  gap-2 md:gap-5 items-center mr-2">
                            <label
                              className={`radio-label flex text-center items-center  justify-center gap-1 md:gap-2 ${
                                wantToUploadResume === true ? "selected" : ""
                              }`}
                            >
                              <p className="md:text-base">Yes</p>
                              <input
                                type="radio"
                                className="cursor-pointer"
                                value="No"
                                checked={wantToUploadResume === true}
                                onChange={() => attachResume(true)}
                              />
                            </label>
                            <label
                              className={`radio-label flex text-center items-center  justify-center gap-1 md:gap-2 ${
                                wantToUploadResume === false ? "selected" : ""
                              }`}
                            >
                              <p className="md:text-base">No</p>
                              <input
                                type="radio"
                                className="cursor-pointer"
                                value="Yes"
                                checked={wantToUploadResume === false}
                                onClick={() => attachResume(false)}
                              />
                            </label>
                          </div>
                        </div>
                      )}

                    {InterviewStore.showResume ? (
                      <div className="my-2  w-full md:w-[70%] lg:w-[65%]">
                        <div className="flex flex-col">
                          <input
                            id="fileInput"
                            type="file"
                            className="hidden"
                            onChange={handleFileChange}
                            accept=".pdf"
                          />
                          <label
                            htmlFor="fileInput"
                            className={`px-4 py-1 w-fit min-w-[95%]  text-center flex items-center border lg:gap border-primary rounded-xl cursor-pointer  transition duration-300 ease-in-out ${
                              InterviewStore.showResume
                                ? "gap-1 justify-center"
                                : "gap-2 "
                            }`}
                          >
                            <p className="font-semibold text-sm">
                              {InterviewStore.resumeFile?.name}
                            </p>{" "}
                            <div
                              className={`flex  items-center  h-[35px] md:text-lg lg:text-xl ${
                                InterviewStore.showResume ? "gap-1" : "gap-2"
                              }`}
                            >
                              <MdFileUpload className="text-primary text-2xl" />{" "}
                              Upload Resume
                            </div>
                          </label>
                          {/* {selectedFileName && (
                        <p className="text-blue-500">{selectedFileName}</p>
                      )} */}
                        </div>
                      </div>
                    ) : null}

                    {/* <div className="opacity-600 mb-2 text-[0.8rem] w-[100%] flex flex-row font-semibold items-center text-text_color3">
                <AiOutlineInfoCircle className="mx-2 text-[1rem]" />
                <p>100 credits will be deducted for each interview</p>
              </div> */}

                    {attempts !== -1 && (
                      <div className="mb-2 w-full md:w-[70%] lg:w-[65%]">
                        <p className=" text-lg">
                          You can attempt{" "}
                          <span className="text-primary text-lg font-bold">
                            {attempts} times
                          </span>{" "}
                          only
                        </p>
                      </div>
                    )}
                    {JSON.parse(localStorage.getItem("interviewDetails"))
                      ?.interviewType === "real" && (
                      <div className="w-full">
                        <button
                          className={`text-primary  underline text-lg w-[95%] md:w-[56%] lg:w-[65%]   h-[40px] `}
                          onClick={() => {
                            InterviewStore.setAdditionalSettings(
                              "camera",
                              false,
                            );
                            InterviewStore.setAdditionalSettings(
                              "resume",
                              false,
                            );
                            InterviewStore.setAdditionalSettings(
                              "screen",
                              false,
                            );
                            InterviewStore.setAdditionalSettings("attempts", 2);
                            setShowMeetingForm(false);
                            PopupStore.setTopicBasedInterview(false);
                            navigate("/dashboard/dashboard");
                          }}
                        >
                          Practice Interview
                        </button>
                      </div>
                    )}
                    <button
                      type="submit"
                      className={`text-bg3 ${
                        invitationLink ? "hidden" : "block"
                      } flex flex-row justify-center ml-[-4%] items-center text-center my-5 text-[18px] font-bold  px-3 rounded-2xl h-[60px] bg-primary w-[95%]  md:w-[67%] lg:w-[61%] gap-2`}
                    >
                      {waiting ? (
                        <FaCircleNotch className="text-primary2 animate-spin text-3xl" />
                      ) : (
                        <span className="text-[30px] text-white text-center w-8 h-8 flex items-center justify-center rounded-full border-2 border-white ">
                          <MdOutlineAdd />
                        </span>
                      )}
                      <p className="ml-2">
                        {waiting ? "Please wait..." : "New Interview"}
                      </p>
                    </button>
                  </form>
                </div>
              </div>
            ) : null
            // <button
            //   onClick={() => setShowMeetingForm(true)}
            //   className=" md-agent-shadoww text-primary2 flex flex-row justify-center md:ml-5 items-center text-center text-[17px]  m-auto px-3  rounded-lg h-[60px] bg-primary w-[100%] lg:w-[95%] md:w-[95%] "
            // >
            //   <span className="text-[30px] text-primary2 ml-5 text-center w-8 h-8 flex items-center justify-center rounded-full bg-primary border border-white ">
            //     <MdOutlineAdd />
            //   </span>{" "}
            //   <p className="ml-5">Create Interview Session</p>
            // </button>
          }
          <div>
            {!PopupStore.topicbasedinterview ? (
              <button
                onClick={() => {
                  handleCompanyInterview();
                  // PopupStore.setCreateInterview(true);
                }}
                className=" text-primary flex flex-row justify-center mt-2 md:ml-5 items-center text-center text-[17px] m-auto px-3 rounded-full h-[60px] lg:text-xl lg:p-6 lg:py-10   md:bg-white lg:bg-white md:border-2 lg:border-2 border-primary  w-[100%] lg:w-[95%] md:w-[95%] transition-colors duration-300 hover:bg-primary hover:text-white "
              >
                {waiting ? (
                  <FaCircleNotch className=" animate-spin text-3xl" />
                ) : (
                  <span className="text-[30px]  text-center w-8 h-8 flex items-center justify-center rounded-full ">
                    <IoAddCircleOutline />
                  </span>
                )}
                <p className="ml-2 gil-med">Create An Interview</p>
              </button>
            ) : null}

            {/* <ReferAndEarnCard /> */}
          </div>
        </div>
      )}
    </Observer>
  );
}

export function ReferAndEarnCard({ shadow = false, onClick }) {
  const { PopupStore } = useStores();

  function showReferAndEarn() {
    PopupStore.setReferAndEarn(true);
    if (onClick) {
      onClick();
    }
  }

  return (
    <div
      className={`bg-white h-[160px] md:mx-auto md:ml-[6%]  mt-5 rounded-lg w-[96%] lg:w-[95%] md:w-[95%] ${
        shadow ? "shadow-xl" : ""
      }`}
    >
      <div className="flex flex-row justify-center ml-5 items-center pt-6 ">
        <div>
          <img src={referal} alt="referal" className="w-40 " />
        </div>
        <div className="mx-3">
          <h1 className="text-lg mb-1">Invite your friends</h1>
          <p className="text-xs  ">
            Refer your friends and both of you get 50 credit points.
          </p>
          <div>
            <div
              className="flex w-32 mt-3 hover:text-primary bg-primary hover:bg-primary2 text-primary2  border hover:border-primary justify-center py-1 rounded-full  cursor-pointer opacity-90"
              onClick={() => showReferAndEarn()}
            >
              <AiOutlineShareAlt className="text-xl mr-1" />
              <p className=" gil-med text-sm ">Refer & Earn</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// export function CreateInterview() {
//   return (

//   );
// }

export function PreviousInterview({ from }) {
  const { UserStore } = useStores();
  // const nointerviewsimage = "./nointerviewshere.png"

  useEffect(() => {
    // UserStore.fetchDashboardInterviews();
    UserStore.hitAllApis();
  }, []);

  const timeStampToDate = (timestamp) => {
    const date = new Date(timestamp);
    const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
    const fullDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return `${fullDate}`;
  };
  const isReportAvailable = () => {
    return (
      <div className="flex ">
        <p className="px-1 text-yellow">
          <FiAlertTriangle />
        </p>
        <p className="text-sm text-yellow">
          {" "}
          you haven't Completed the interview
        </p>
      </div>
    );
  };

  return (
    <Observer>
      {() => (
        <div className=" w-[100%] mx-auto items-center flex flex-col justify-center ">
          {UserStore?.dashboardInterviews.length === 0 ? (
            <div className="w-[95%]  past-interviews   ">
              <div className="  rounded-[15px] w-full mb-0 md:mb-[100%] lg:mb-[100%] flex flex-col items-center justify-center ">
                {/* <h1 className="text-[25px] text-[#010E78]  ">
            No Previous Interviews
          </h1> */}
                <img
                  src={nointerviewsimage}
                  className="w-[250px] h-[250px] rounded-full"
                  alt=""
                />
                <p className="text-base text-primary  ">
                  No Previous Interviews
                </p>
              </div>
            </div>
          ) : (
            <div className="w-[100%] md:w-[100%] lg:w-[90%] m-auto h-[103vh] md:ml-3 bg-slate-100   rounded-lg overflow-y-scroll no-scrollbar">
              <div className="w-[96%] md:w-[95%] lg:w-[90%]  md:mx-auto lg:mx-auto  past-interviews mx-auto  ">
                {UserStore.dashboardInterviews
                  .slice()
                  .reverse()
                  .map((interview, index) => (
                    <div className="w-[100%]  pb-[10px] h-[200px] bg-white -ml-2 rounded-[10px] mt-[17px] flex  justify-center gap-2">
                      <span className=" flex flex-row pt-5 px-3 ">
                        {UserStore?.dashboardInterviews?.length - index < 10 ? (
                          <h1 className="text-[20px]  bg-gray-200 h-10 text-text_color3 border border-1  rounded-md px-3 mb-auto py-1">
                            0{UserStore?.dashboardInterviews?.length - index}
                          </h1>
                        ) : (
                          <h1 className="text-[20px] my-1 bg-gray-200 h-10 text-text_color3 border border-1  rounded-md px-3 mb-auto py-1">
                            {UserStore?.dashboardInterviews?.length - index}
                          </h1>
                        )}
                      </span>
                      <div className="flex flex-col items-start pt-4 ">
                        <div className="flex flex-col text-start  ">
                          <p className=" text-[17.52px] my-auto  text-text_color3">
                            Topic: {interview?.technology}
                          </p>
                          <div className="flex flex-row ">
                            <p className=" text-[17.52px] my-auto text-primary ">
                              <span className=" text-text_color3 ">Level:</span>{" "}
                              {interview?.levelOfInterview}
                            </p>
                            <p className=" mx-auto my-auto text-xs text-text_color3 opacity-70 px-3 ">
                              {timeStampToDate(interview?.createdAt)}
                            </p>
                          </div>
                          <h1 className="text-[17px] my-auto text-text_color3 rounded-md py-1">
                            Questions: {interview?.noOfQuestions}
                          </h1>
                        </div>

                        {interview?.isInterviewCompleted &&
                        interview?.isResultPublished ? (
                          <div className="flex text-xs  text-black  ">
                            <div className=" pr-2">
                              <p className=" gil-med text-lg ">
                                {typeof interview?.result[2]?.score ===
                                  "number" &&
                                !isNaN(interview?.result[2]?.score)
                                  ? interview?.result[2]?.score.toFixed(1)
                                  : 0}
                                %
                              </p>
                              <p className="text-[10px] opacity-70">
                                Communication
                              </p>
                            </div>
                            <div className=" px-2">
                              <p className="text-lg gil-med">
                                {typeof interview?.result[1]?.score ===
                                  "number" &&
                                !isNaN(interview?.result[1]?.score)
                                  ? interview?.result[1]?.score.toFixed(1)
                                  : 0}
                                %
                              </p>
                              <p className="text-[10px] opacity-70">
                                Technical Skills{" "}
                              </p>
                            </div>
                            <div className=" px-2">
                              <p className="text-lg gil-med ">
                                {typeof interview?.result[0]?.score ===
                                  "number" &&
                                !isNaN(interview?.result[0]?.score)
                                  ? interview?.result[0]?.score.toFixed(1)
                                  : 0}
                                %
                              </p>
                              <p className="text-[10px] opacity-70">
                                Over all score
                              </p>
                            </div>
                          </div>
                        ) : (
                          <div className="">{isReportAvailable()}</div>
                        )}

                        <Link
                          to={
                            from === "mobile"
                              ? `/report/${interview?._id}`
                              : `/dashboard/report/${interview?._id}`
                          }
                          className=" text-right my-auto flex items-center text-sm justify-start w-full "
                        >
                          {" "}
                          <span className="text-primary">View more</span>{" "}
                          <MdArrowCircleRight className="text-primary mx-1" />
                        </Link>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      )}
    </Observer>
  );
}

export function PreviousMeetingDetails() {
  const { UserStore } = useStores();

  const previousmeetingtime = (timestamp) => {
    const date = new Date(timestamp);
    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    return `${time}`;
  };

  const previousmeetingdate = (timestamp) => {
    const date = new Date(timestamp);
    const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
    const fullDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return `${dayOfWeek}, ${fullDate}`;
  };
  return (
    <div className="flex flex-col w-[100%] h-[55vh]">
      <div className="bg-[#E7E7E7E3] w-[90%] h-[2px] mt-[5px] mx-auto "></div>

      <div className="flex flex-col mt-[2%] justify-center w-[100%]">
        <h1 className="text-center text-black md:text-2xl ">
          Previous meeting details
        </h1>
        <div className="flex flex-row justify-center w-[100%] mt-[2%] ">
          <p className="flex text-lg text-[#8D8D8D] mx-[5%]">
            {" "}
            <MdAvTimer />{" "}
            {previousmeetingtime(
              UserStore?.dashboardInterviews[
                UserStore?.dashboardInterviews?.length - 1
              ]?.createdAt ?? "not available",
            )}
          </p>
          <p className="flex text-lg text-[#8D8D8D] mx-[5%] ">
            {" "}
            <MdOutlineCalendarMonth />{" "}
            {previousmeetingdate(
              UserStore?.dashboardInterviews[
                UserStore?.dashboardInterviews?.length - 1
              ]?.createdAt ?? "not available",
            )}
          </p>
        </div>
      </div>
      <p className="mt-5 text-[#8D8D8D]  text-lg  text-center">
        Topic of Interview:{" "}
        {UserStore?.dashboardInterviews[
          UserStore?.dashboardInterviews?.length - 1
        ]?.technology ?? "not available"}{" "}
      </p>
      <p className="mt-5 text-lg  text-center ">
        Level of interview:{" "}
        {UserStore?.dashboardInterviews[
          UserStore?.dashboardInterviews?.length - 1
        ]?.levelOfInterview ?? "not available"}{" "}
      </p>
      <div className="flex flex-row justify-around">
        <p className="mt-5 text-lg  text-center ">
          Number of questions:{" "}
          {UserStore?.dashboardInterviews[
            UserStore?.dashboardInterviews?.length - 1
          ]?.noOfQuestions ?? "not available"}{" "}
        </p>
        <p className="mt-5 text-lg  text-center ">
          score{" "}
          <b className="text-[#8D8D8D]">
            {UserStore?.dashboardInterviews[
              UserStore?.dashboardInterviews?.length - 1
            ]?.score ?? ""}
            /10
          </b>{" "}
        </p>
      </div>
    </div>
  );
}

export function UserDetails({ from, onclickEdit }) {
  const [studentDetails, setstudentDetails] = useState({});
  const { UserStore, PopupStore } = useStores();
  const userGoogleDetails = JSON.parse(localStorage.getItem("user_google"));
  const profile = userGoogleDetails.picture;
  const [pic, setPic] = useState(profile);
  const defaultProfile =
    "https://t4.ftcdn.net/jpg/02/15/84/43/360_F_215844325_ttX9YiIIyeaR7Ne6EaLLjMAmy4GvPC69.jpg";
  // const [availableCredits, setAvailableCredits] = useState(null);
  const navigate = useNavigate();
  // const fetchCoinsFromStore = () => {
  //   try {
  //     const user = UserStore?.userDetails;

  //     if (user) {
  //       setAvailableCredits(user?.coins);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   fetchCoinsFromStore();
  // }, []);

  const getStudentDetails = async () => {
    try {
      let studentDetails = await JSON.parse(localStorage.getItem("user"));
      setstudentDetails(studentDetails);
      let google_user = await JSON.parse(localStorage.getItem("user_google"));
      setPic(google_user?.picture);
    } catch (error) {
      console.log(error);
    }
  };

  const goToProfile = () => {
    if (from === "mobile") {
      onclickEdit && onclickEdit();
    }
    navigate("/dashboard/settings");
  };

  useEffect(() => {
    getStudentDetails();
  }, []);

  return (
    <Observer>
      {() => (
        <div>
          <div className="flex flex-col  my-8 w-[100%] items-center">
            <div className="flex flex-row  border-b-[0.95px] pb-8 border-border3 justify-between mt-2 w-[90%]">
              <div className="flex flex-row items-center relative w-[80%] cursor-pointer">
                <div className="w-40">
                  <ProfilePic pic={pic} />
                </div>
                <div className="flex flex-col ">
                  <h1 className="text-[25px] text-centerfont-[400] text-primary">
                    {UserStore?.userDetails?.name}
                  </h1>
                  <p className="text-sm opacity-60 text-text_color3 leading-[20px]">
                    {UserStore?.userDetails?.mail}
                  </p>
                  <p className="text-sm opacity-60 text-text_color3 leading-[20px]">
                    {UserStore?.userDetails?.role?.role}
                  </p>
                </div>
              </div>
              <Tooltip
                id="editdetailstooltip"
                position="bottom-end"
                content="Edit your profile"
              >
                <button
                  onClick={goToProfile}
                  className="flex flex-col mt-14 items-center"
                >
                  <BiEditAlt className="text-text_color3 w-[20px] h-[20px] " />
                  <p className="text-[10px] text-text_color3 w-[70px]">
                    Edit Details
                  </p>
                </button>
              </Tooltip>
            </div>
            <div className="w-full flex-col ">
              <div className="m-auto flex flex-col md:flex-row lg:flex-row justify-center items-center my-2 w-[90%]">
                <CreditPoints
                  className="w-[50%] "
                  availableCredits={UserStore.userDetails?.coins ?? 0}
                />

                <div className=" md:w-[50%] lg:w-[50%] w-full lg:mt-7 md:mt-7">
                  <InterviewsCompleted className="w-full " />
                </div>
              </div>
              {/* {getMoreCreditsButton()} */}
            </div>
          </div>
          <Skills onClickSkills={goToProfile} />
        </div>
      )}
    </Observer>
  );

  // function getMoreCreditsButton() {

  //   return (
  //     <div className="flex flex-col items-center  w-[90%] h-full m-auto">
  //       <button
  //         onClick={showPopUP}
  //         className=" rounded-xl mt-2 flex items-center justify-center hover:bg-primary bg-primary2 text-lg hover:text-white font-semibold  text-primary py-2 px-4 w-full"
  //       >
  //         <FaCoins className="mr-4 underline text-2xl" />
  //         Get Credit Points
  //       </button>
  //     </div>
  //   );
  // }
}

export function Skills({ onClickSkills }) {
  // const [studentDetails, setstudentDetails] = useState({});
  const { UserStore } = useStores();
  // console.log(onClickSkills)
  // const getStudentDetails = async () => {
  //   try {
  //     let studentDetails = await JSON.parse(
  //       localStorage.getItem("user")
  //     );
  //     setstudentDetails(studentDetails);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   getStudentDetails();
  // }, []);

  return (
    <Observer>
      {() => (
        <div>
          <div className="flex flex-col my-[2%] mx-[5%] w-[95%] ">
            <p className="text-[20px]  text-black  ">Skills:</p>
            {UserStore.userDetails?.skills?.length === 0 ? (
              <>
                {/* <EmptySkill /> */}
                <AddSkills onClick={onClickSkills && onClickSkills} />
              </>
            ) : (
              <div className="flex flex-wrap gap-3 h-auto mx-3">
                {UserStore.userDetails?.skills?.map((skill) => (
                  <p className="text-[15px] rounded-lg bg-gray-200 py-1 gil-med text-gray-500 px-4">
                    {skill}
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </Observer>
  );
}

export function EmptySkill() {
  return (
    <div className="flex flex-col mx-3">
      <div className="flex w-[100%] h-auto ">
        {[].map((item) => (
          <p className="text-[15px] rounded-lg   py-1 text-primary bg-primary2 px-4 w-[80px] h-[30px] m-3 "></p>
        ))}
      </div>
      <p className="text-base  mx-3 py-1 text-primary">No Skills Available</p>
    </div>
  );
}

export function EmptyCity() {
  return (
    <div className="flex flex-col mx-3">
      <div className="flex w-[100%] h-auto ">
        {[].map((item) => (
          <p className="text-[15px] rounded-lg   py-1 text-primary bg-primary2 px-4 w-[80px] h-[30px] m-3 "></p>
        ))}
      </div>
      <p className="text-base  mx-3 py-1 text-primary">No City Available</p>
    </div>
  );
}

export function AddSkills({ onClick }) {
  const navigate = useNavigate();

  const goToLearnPage = () => {
    if (onClick) {
      return onClick();
    }

    return navigate("/dashboard/settings");
  };
  return (
    <div className="flex items-center mx-3 h-[15vh] overflow-y-hidden">
      <div
        className="flex flex-col items-center justify-center cursor-pointer border-2 border-primary h-20 w-20 rounded-full  bg-primary2 "
        onClick={goToLearnPage}
      >
        <MdOutlineAdd className="text-4xl mb-2 text-primary" />
        <p className="text-xs mb-[-40px] mt-3 text-primary">Add skills</p>
      </div>
      <p className="text-base  mx-3 py-1 text-primary">No Skills Available</p>
      {/* <p className="flex justify-start text-primary mx-3">Add Courses <br /> to learn new things...!</p> */}
    </div>
  );
}

export function InterviewsCompleted() {
  const { UserStore, PopupStore, CommonStore } = useStores();
  const showPopUP = () => {
    PopupStore.setGetMoreCredits(true);
  };
  return (
    <Observer>
      {() => (
        // <div className="flex flex-row py-2 md:mt-9 lg:mt-9 md:w-[50%] lg:w-[50%] w-[43vw] mt-[-90px] md:ml-[30px] lg:ml-[30px] justify-end">
        //   <p className="text-text_color3 md:text-xl lg:text-xl mt-[3px] ml-[-30px] mr-[10px] text-[10px]">
        //     Interviews Completed
        //   </p>
        //   <p className="text-primary w-[50px] mr-[-40%] md:w-[70%] lg:w-[70%] md:h-[50px] lg:h-[50px] h-[30px] rounded-[10px] text-center mt-[-3px] md:mt-3 bg-primary2 md:text-[30px] lg:text-[30px] text-[20px]">
        //     {UserStore?.dashboardInterviews?.length}
        //   </p>
        // </div>
        <div className="md:flex md:flex-row-reverse lg:flex lg:flex-row-reverse">
          {/* <p
            className="text-right text-xs  hidden items-center gap-1 w-36 md:w-8 lg:w-8 md:flex lg:flex md:justify-end lg:justify-end md:items-end lg:items-end cursor-pointer lg:text-sm lg:pt-5 "
            onClick={() => {
              PopupStore.setKnowMore(true);
            }}
          >
            {" "}
            <AiOutlineInfoCircle className="lg:text-xl text-xl md:mb-2 lg:mb-4" />
           
          </p> */}
          <Tooltip
            id="getcreditpointstooltip"
            position="bottom"
            content="click here to get credit points"
          >
            <div className="flex md:justify-end md:items-end lg:justify-end lg:items-end md:w-56 lg:w-60">
              {/* <div
                className="flex lg:w-[100%] md:w-[100%] w-[95%] h-[5.5vh] rounded-full items-center border-2 mt-2 border-primary justify-center cursor-pointer lg:px-1 md:px-1"
                onClick={() => {
                  showPopUP();
                }}
              >
                <MdOutlineAdd className="bg-primary text-primary2 rounded-full text-sm md:text-xl lg:text-xl" />{" "}
                <p className="gil-med ml-3 md:ml-1 lg:ml-1 ">
                  Get Credit Points
                </p>
              </div> */}
            </div>
          </Tooltip>
          {/* <div
            className="md:hidden cursor-pointer flex items-center justify-end text-primary mt-5 w-[90%]"
            onClick={() => {
              PopupStore.setReferAndEarn(true);
            }}
          >
            <p className="underline">Refer & Earn</p>
          </div> */}
        </div>
      )}
    </Observer>
  );
}

export const RadialBarChart = ({ label, score, color }) => {
  const circumference = 2 * Math.PI * 50;
  const progress = (score / 100) * circumference;

  return (
    <div className="lg:my-3 md:my-3 my-3 ">
      <div className="relative   w-20 h-20 lg:h-40 lg:w-40 rounded-full m-2">
        <svg
          className="absolute top-0 left-0 w-full h-full"
          viewBox="0 0 100 100"
        >
          <circle
            className="text-primary2 stroke-current"
            cx="50"
            cy="50"
            r="45"
            fill="none"
            strokeWidth="10"
          />
          <circle
            className={classNames(
              "text-primary stroke-current transition-all duration-500",
              {
                "stroke-dashoffset-0": score > 0,
                "stroke-dashoffset-full": score === 0,
              },
            )}
            style={{ color: `${color}` }}
            cx="50"
            cy="50"
            r="45"
            fill="none"
            strokeWidth="10"
            strokeDasharray={circumference - 15}
            strokeDashoffset={circumference - progress}
            strokeLinecap="round"
            transform="rotate(-90, 50, 50)"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-text_color3 font-bold text-2xl lg:text-4xl">
          {score}%
          <br />
        </div>
      </div>
      <div className="flex items-center justify-center text-text_color3 text-sm lg:text-2xl">
        {label}
      </div>
    </div>
  );
};

export const EnrolledCourseCircle = ({ label, score, image, key, id }) => {
  const circumference = 2 * Math.PI * 45;
  const progress = (score / 100) * circumference;

  const navigate = useNavigate();
  const goToCourseById = (id) => {
    if (window.innerWidth > 768) {
      navigate(`/dashboard/course/${id}`);
    } else {
      navigate(`/course/${id}`);
    }
  };
  return (
    <div className={`my-2 flex flex-col items-center justify-center`} key={key}>
      <div
        className="relative  w-32 h-32 rounded-full m-2 cursor-pointer"
        onClick={() => goToCourseById(id)}
      >
        <svg
          className="absolute top-0 left-0 w-full h-full"
          viewBox="0 0 100 100"
        >
          <circle
            className="text-primary2 stroke-current"
            cx="50"
            cy="50"
            r="45"
            fill="none"
            strokeWidth="10"
          />
          <circle
            className={classNames(
              "text-primary stroke-current transition-all duration-500",
              {
                "stroke-dashoffset-0": score > 0,
                "stroke-dashoffset-full": score === 0,
              },
            )}
            cx="50"
            cy="50"
            r="45"
            fill="none"
            strokeWidth="10"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progress}
            strokeLinecap="round"
            transform="rotate(-90, 50, 50)"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-text_color3 font-bold text-2xl">
          {/* {score} */}
          <img
            className="w-[90px] h-[90px] rounded-full object-cover"
            src={`${image}`}
            alt=""
          />
        </div>
      </div>
      <div className="flex items-center justify-center text-text_color3 text-center text-sm w-44 truncate">
        {label} <br />
        {score}%
      </div>
    </div>
  );
};

export function Report() {
  const { UserStore } = useStores();

  return (
    <Observer>
      {() => (
        <div className="flex flex-col mt-1 mx-8 w-fit">
          <p className="text-[20px]  text-black  ">
            Skills based on Recent Interviews
          </p>
          <div className=" rounded-lg  flex flex-col lg:flex-row md:flex-row gap-12 items-center justify-between">
            <RadialBarChart
              score={UserStore.userDetails?.technicalSkills ?? 0}
              label={"Technical skills"}
            />
            <RadialBarChart
              score={UserStore.userDetails?.communicationSkills ?? 0}
              label={"Communication skills"}
            />
            <RadialBarChart
              score={UserStore.userDetails?.overallRating ?? 0}
              label={"Overall Score"}
            />
          </div>
        </div>
      )}
    </Observer>
  );
}

export function Progress_bar({ label, image, score, key, id }) {
  const navigate = useNavigate();
  const goToCourseById = (id) => {
    if (window.innerWidth > 768) {
      navigate(`/dashboard/course/${id}`);
    } else {
      navigate(`/course/${id}`);
    }
  };
  return (
    <>
      <div
        className="flex mt-1 my-3 mx-8 w-[100%]  items-center cursor-pointer"
        onClick={() => goToCourseById(id)}
      >
        <img
          src={image}
          className="h-[40px] w-[40px] object-cover rounded-full"
        />
        <p className="w-[100px]  truncate ml-5 gil-bold text-black opacity-80">
          {label}
        </p>
        <div className="w-[60%] h-[12px] rounded-full ml-2 overflow-hidden bg-gray-200">
          <div
            className="bg-primary h-full rounded-full "
            style={{ width: `${score}%` }}
          ></div>
        </div>
        <p className="w-[60px] ml-2 gil-bold text-black opacity-80">{score}%</p>
      </div>
    </>
  );
}

export function EnrolledCourses({ onClickEmptyEnroll, showAll = false }) {
  // const navigate = useNavigate();
  const { LearningStore } = useStores();
  // function joshnavi(){
  //   if(LearningStore?.enrolledCourses > 2){
  //     showAll = false;
  //   }
  //   else{
  //     showAll = true;
  //   }
  // }
  // useEffect(() => {
  //   joshnavi();
  // }, [])
  const navigateToLearnPage = () => {
    // navigate("/dashboard/learn");
    if (onClickEmptyEnroll) {
      return onClickEmptyEnroll();
    }
  };
  return (
    <div className="flex flex-col mt-1 my-3 mx-8  md:mx-10 lg:mx-10 md:px-2 lg:px-2 w-[100%] ">
      <p className="text-[20px]  text-black  ">Enrolled Courses</p>
      {!showAll ? (
        <div className="flex flex-col py-3 w-[90%] gap-5 h-52 items-center overflow-hidden no-scrollbar ">
          {LearningStore.enrolledCourses.length === 0 && (
            <EnrollForCourses
              onClick={() => {
                if (onClickEmptyEnroll) {
                  return onClickEmptyEnroll();
                }
              }}
            />
          )}
          {LearningStore.enrolledCourses
            .slice()
            .sort((a, b) => b.createdAt - a.createdAt)
            .map((enroll, index) => {
              return Progress_bar({
                label: enroll?.course?.title,
                score: LearningStore.getTheCourseCompletionPercentage(
                  enroll?.course?._id,
                ),
                image: enroll?.course?.image,
                key: index,
                id: enroll?.course?._id,
              });
              // <div className="flex flex-row justify-center items-center w-[50%] overflow-x-scroll no-scrollbar ">
              //   <img className="w-[90px] h-[90px] rounded-full p-2 border-2 border-primary" src={course?.image} alt="" />
              // </div>
            })}
        </div>
      ) : (
        <div className="flex flex-col py-3 w-[90%] gap-5 items-center overflow-hidden no-scrollbar ">
          {LearningStore.enrolledCourses.length === 0 && (
            <EnrollForCourses
              onClick={() => {
                if (onClickEmptyEnroll) {
                  return onClickEmptyEnroll();
                }
              }}
            />
          )}
          {LearningStore.enrolledCourses
            .slice()
            .sort((a, b) => b.createdAt - a.createdAt)
            .map((enroll, index) => {
              return Progress_bar({
                label: enroll?.course?.title,
                score: LearningStore.getTheCourseCompletionPercentage(
                  enroll?.course?._id,
                ),
                image: enroll?.course?.image,
                key: index,
                id: enroll?.course?._id,
              });
              // <div className="flex flex-row justify-center items-center w-[50%] overflow-x-scroll no-scrollbar ">
              //   <img className="w-[90px] h-[90px] rounded-full p-2 border-2 border-primary" src={course?.image} alt="" />
              // </div>
            })}
        </div>
      )}
      {LearningStore.enrolledCourses.length > 2
        ? !showAll && (
            <p
              className="mt-3  md:w-[90%] lg:w-[90%] w-[80%] justify-end text-primary text-sm flex items-center gap-1 cursor-pointer"
              onClick={navigateToLearnPage}
            >
              <AiOutlineDownCircle />
              <p className="text-sm"> View More</p>
            </p>
          )
        : null}
    </div>
  );
}

export function EnrolledCoursesProgressBar({ onCLickEmptyEnroll }) {
  const { LearningStore } = useStores();
  return (
    <div>
      <div className="flex flex-col mt-1 my-3 mx-8 w-[100%] ">
        <p className="text-[20px]  text-black  ">Enrolled Courses</p>
        <div className="flex flex-col py-3 w-[90%] gap-10 items-center overflow-x-auto no-scrollbar ">
          {LearningStore.enrolledCourses.length === 0 && (
            <EnrollForCourses
              onClick={() => {
                if (onCLickEmptyEnroll) {
                  return onCLickEmptyEnroll();
                }
              }}
            />
          )}
          {LearningStore.enrolledCourses
            .slice()
            .sort((a, b) => b.createdAt - a.createdAt)
            .map((enroll, index) => {
              return Progress_bar({
                label: enroll?.course?.title,
                score: LearningStore.getTheCourseCompletionPercentage(
                  enroll?.course?._id,
                ),
                image: enroll?.course?.image,
                key: index,
                id: enroll?.course?._id,
              });
              // <div className="flex flex-row justify-center items-center w-[50%] overflow-x-scroll no-scrollbar ">
              //   <img className="w-[90px] h-[90px] rounded-full p-2 border-2 border-primary" src={course?.image} alt="" />
              // </div>
            })}
        </div>
      </div>
    </div>
  );
}

export function EnrollForCourses({ onClick }) {
  const navigate = useNavigate();

  const goToLearnPage = () => {
    if (onClick) {
      return onClick();
    }

    return navigate("/dashboard/learn");
  };
  return (
    <div className="flex items-center justify-start h-[15vh] overflow-y-hidden">
      <div
        className="flex flex-col items-center justify-center cursor-pointer border-2 border-primary h-20 w-20 rounded-full  bg-primary2 "
        onClick={goToLearnPage}
      >
        <MdOutlineAdd className="text-4xl mb-2 text-primary" />
        <p className="text-xs mb-[-40px] mt-3 text-primary">Enroll course</p>
      </div>
      <p className="flex justify-start text-primary mx-3">
        Enroll Courses <br /> to learn new things...!
      </p>
    </div>
  );
}
